import { useQuery, UseQueryOptions } from 'react-query'
import { AxiosError } from 'axios'

import { getProject } from 'api/clients'
import { GETProjectResponse } from 'api/types'
import { QueryKey } from 'constants/endpoint'
import { useClient } from './useClient'

type TData = GETProjectResponse
type TError = AxiosError<unknown>

export const useGetProject = (
  projectId: string,
  options?: UseQueryOptions<TData, TError>
) => {
  const client = useClient()

  return useQuery<TData, TError>(
    [QueryKey.PROJECT_DETAIL, projectId],
    async () => {
      return getProject(
        {
          projectId
        },
        client
      )
    },
    options
  )
}
